import React from 'react';
import { FieldArray } from 'redux-form';
import { Aliases, Corporations } from './components';
import { Row, Col } from 'antd';
import { FormField } from 'common';
import globalStyles from 'common/global.module.scss';

const NameTab: React.FC<{
  handleFieldFocus: any;
  tabNamePrefix: string;
  className?: string;
  autoFocusIndividual?: boolean;
}> = ({
  handleFieldFocus,
  tabNamePrefix,
  className = '',
  autoFocusIndividual = true,
}) => {
  const checkboxes = [
    {
      name: `${tabNamePrefix}.judgmentsLiens`,
      tooltip: 'Judgments/Liens',
      text: 'Judgments/Liens',
    },
    {
      name: `${tabNamePrefix}.ftl`,
      tooltip: 'Federal Tax Liens',
      text: "FTL's",
    },
    {
      name: `${tabNamePrefix}.parkingViolations`,
      tooltip: 'Parking Violation Judgments',
      text: "PVB's",
    },
    {
      name: `${tabNamePrefix}.ecb`,
      tooltip: 'Environmental Control Board Judgments',
      text: "ECB's",
    },
    {
      name: `${tabNamePrefix}.tab`,
      tooltip: 'Transit Adjudication Bureau Judgments',
      text: "TAB's",
    },
    {
      name: `${tabNamePrefix}.ucc`,
      tooltip: 'Uniform Commercial Codes',
      text: "UCC's",
    },
    {
      name: `${tabNamePrefix}.recordedDocuments`,
      tooltip: 'Recorded Documents',
      text: 'Recorded Documents',
    },
  ];

  const aliasesFieldArrayName = `${tabNamePrefix}.aliases`;
  const corporationsFieldArrayName = `${tabNamePrefix}.corporations`;

  return (
    <>
      <Row type="flex" align="middle" className={className}>
        {checkboxes.map((item) => (
          <FormField
            key={item.name}
            className={`m-0`}
            inputType="checkbox"
            name={item.name}
            id={item.name}
            tooltip={item.tooltip}
          >
            {item.text}
          </FormField>
        ))}
      </Row>
      <Row type="flex" align="middle" className={className}>
        <FormField
          className={`m-0`}
          inputType="checkbox"
          name={`${tabNamePrefix}.acris`}
          id="nameTab.acris"
        >
          Search All Acris Counties for FTL's
        </FormField>
      </Row>
      <Row type="flex" gutter={16} className={className}>
        <Col>
          <FormField
            className={`m-0`}
            name={`${tabNamePrefix}.searchByIndividual`}
            inputType="checkbox"
            autoFocus={autoFocusIndividual}
          >
            Individual
          </FormField>
          <div className={globalStyles.row}>
            <FieldArray
              name={aliasesFieldArrayName}
              component={Aliases}
              handleFieldFocus={handleFieldFocus}
            />
          </div>
          <FormField
            className={`m-0`}
            name={`${tabNamePrefix}.searchByCorporation`}
            inputType="checkbox"
            value="corporation"
          >
            Corporation
          </FormField>
          <div className={globalStyles.row}>
            <FieldArray
              name={corporationsFieldArrayName}
              component={Corporations}
              handleFieldFocus={handleFieldFocus}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(NameTab);
